import type {
  IChannelsDto,
  IChannelsGetAllParams,
  IChannelsGetAllResponse,
} from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { messages } from "@api/channels/messages/api";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IChannelsGetAllResponse>>,
  IPathBaseParam,
  IPaginationParams & IChannelsGetAllParams
>("channels");
const patchApis = createPatchApi<
  IApiResponse<IChannelsGetAllResponse>,
  IPathByIdParam,
  IChannelsDto
>("channels");

export const channels = {
  ...getAllApis,
  ...patchApis,
  messages,
};
